import { useEffect, useState } from 'react';
import useViewport from '@/common/context/ViewPort/useViewPort';

export const useStyleClass = (className: string, isExtensive = false) => {
  const screen = useViewport(isExtensive);
  const [styleClass, setStyleClass] = useState(`${className}--${screen}`);

  useEffect(() => {
    setStyleClass(`${className}--${screen}`);
  }, [className, screen]);

  return styleClass;
};
